import { RootState } from 'state/reducers';

export const ConfigurableHyperLinkSelector = (state: RootState) => state.hyperlink.values;
